if (!customElements.get("section-calculateur")) {
  customElements.define(
    "section-calculateur",
    class SectionCalculateur extends HTMLElement {
      constructor() {
        super();
        this.range = this.querySelector("input[type=range]");
        this.range.addEventListener("input", this.onInputHandler.bind(this));
        this.bubble = this.querySelector(".range-slider-cursor");
        this.bubble.textContent = this.range.value;
        this.benefits = this.querySelectorAll(".section-calculateur--benefits .benefit");
      }
      onInputHandler(evt) {
        this.bubble.innerHTML = evt.target.value;
        // adapt the bubble position
        const w = this.range.offsetWidth;
        const tw = 61;
        const xPX = ((evt.target.value - 1) * (w - tw)) / 6;
        this.bubble.style.left = `${xPX}px`;
        this.updateBenefits(evt.target.value);
      }
      updateBenefits(value) {
        this.benefits.forEach((benefit) => {
          const benefitValue = parseInt(benefit.dataset.value) * value;
          const benefitSuffix = benefit.dataset.suffix;
          const benefitValueSpan = benefit.querySelector(".benefit-value");
          benefitValueSpan.innerHTML = `${benefitValue}${benefitSuffix}`;
        });
      }
    }
  );
}
